import { useEffect, useRef, useContext } from 'react';
import { StoreContext } from 'pages/_app';
import { toJS } from 'mobx';

const useGTMUserData = () => {
  const store = useContext(StoreContext);
  const userStore = toJS(store?.userStore);
  const hasPushed = useRef(false);

  const { currentUser, defaultRegion, locationName, userLogin } = userStore;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (hasPushed.current) return;
    if (!userLogin) return;

    const userName =
      (currentUser?.attributes?.first_name || '') +
      ' ' +
      (currentUser?.attributes?.last_name || '');
    const officeName = locationName || null;

    if (userName.trim() || officeName) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'userDataReady',
        'user name': userName.trim(),
        'Office Name': officeName,
      });

      hasPushed.current = true;
    }
  }, [userLogin, currentUser, locationName]);
};

export default useGTMUserData;
